import { render, staticRenderFns } from "./DrawerMasterVideo.vue?vue&type=template&id=4e5eb458&scoped=true&"
import script from "./DrawerMasterVideo.vue?vue&type=script&lang=js&"
export * from "./DrawerMasterVideo.vue?vue&type=script&lang=js&"
import style0 from "./DrawerMasterVideo.vue?vue&type=style&index=0&id=4e5eb458&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5eb458",
  null
  
)

export default component.exports